import pick from "lodash/pick";
import { havePermission } from "../../permissions";
import LAYERS_PERMISSIONS from "../../permissions/Layers.json";
import { selectedPolygonTypes } from "../Common/Constants";

const { digitalPersona } = selectedPolygonTypes;

const getdigitalPersonaRange = data => {
	const min = Math.min(...data.map(obj => obj.population));
	const max = Math.max(...data.map(obj => obj.population));
	return { min, max };
};

const getdigitalPersonaPolygon = locations => {
	return {
		polygons: locations.map((obj, ind) => {
			const { popular_times, population: filterData } = obj;
			return {
				id: ind,
				_id: ind,
				coordinates: obj.coordinates,
				style: {
					fillColor: "#FF000077",
					strokeColor: "#00000055",
					zindex: 10
				},
				data: {
					filterData,
					key: "population",
					popular_times
				},
				polygonClick: true,
				type: digitalPersona
			};
		})
	};
};

const getdigitalPersonaSlider = ({ locations, sliderHandler, type }) => {
	if (!havePermission(LAYERS_PERMISSIONS.LAYER_DIGITAL_PERSONA_SLIDER)) return null;
	const { min, max } = getdigitalPersonaRange(locations);
	return {
		min,
		max,
		sliderHandler,
		type
	};
};

const digitalPersonaDataService = {
	all: ({ locations, type, sliderHandler }) => {
		return {
			...pick(getdigitalPersonaPolygon(locations), ["polygons"]),
			slider: getdigitalPersonaSlider({ sliderHandler, locations, type })
		};
	},
	polygons: ({ locations }) => {
		return pick(getdigitalPersonaPolygon(locations), ["polygons"]);
	}
};

export default digitalPersonaDataService;
export { getdigitalPersonaPolygon, getdigitalPersonaSlider, getdigitalPersonaRange };
